import { ICultureResources } from '../../models/resource.model';

export const viVN: ICultureResources = {
    cssVars: {
        fontFamilyTitle: 'Noto Sans Variable',
        fontFamilyText: 'Noto Sans Variable',
    },
    preloads: [
        {
            tag: 'link',
            location: 'head',
            attributes: {
                href: '/assets/fonts/noto-sans/files/noto-sans-vietnamese-wdth-normal.woff2',
                rel: 'preload',
                as: 'font',
                type: 'font/woff2',
                crossorigin: 'anonymous',
            },
        },
    ],
    styles: [
        {
            tag: 'link',
            location: 'head',
            persist: true,
            attributes: {
                href: '/assets/fonts/noto-sans/index.css',
                rel: 'stylesheet',
            },
        },
    ],
};
